import { apiCall } from '../../../services/apiUtil';

// Ping Pong Game API
export const pingpongGameAPI = {
  create: async (gameData) => {
    const payload = {
      eventId: gameData.eventId,
      tournamentRoundId: gameData.tournamentRoundId,
      format: gameData.format || 'singles',
      pointsToWin: gameData.pointsToWin || 11,
      winByTwo: gameData.winByTwo !== false,
      bestOf: gameData.bestOf || 3,
      playerA: gameData.playerA,
      playerB: gameData.playerB,
      servingPlayer: gameData.servingPlayer || 'A',
      status: gameData.status || 'in_progress',
    };

    return apiCall('/games', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  getById: async (id) => {
    return apiCall(`/games/${id}`);
  },

  getByEventId: async (eventId) => {
    return apiCall(`/games/event/${eventId}`);
  },

  update: async (gameId, updateData) => {
    const result = await apiCall(`/games/${gameId}`, {
      method: 'PATCH',
      body: JSON.stringify(updateData),
    });
    return result;
  },

  setInitialServe: async (gameId, servingPlayer, servingPlayerId) => {
    return apiCall(`/games/${gameId}/pingpong/serve`, {
      method: 'PATCH',
      body: JSON.stringify({
        servingPlayer,
        ...(servingPlayerId != null && { servingPlayerId }),
      }),
    });
  },

  recordRally: async (gameId, rallyData) => {
    const payload = {
      pointWinner: rallyData.pointWinner,
      ...(rallyData.shotType            != null && { shotType:            rallyData.shotType }),
      ...(rallyData.scoredByPlayerId    != null && { pointWinnerPlayerId: rallyData.scoredByPlayerId }),
      ...(rallyData.errorByPlayerId     != null && { pointLoserPlayerId:  rallyData.errorByPlayerId }),
    };

    return apiCall(`/games/${gameId}/pingpong/rallies`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  undoLastRally: async (gameId) => {
    return apiCall(`/games/${gameId}/pingpong/rallies/last`, {
      method: 'DELETE',
    });
  },

  completeMatch: async (gameId, matchData) => {
    return apiCall(`/games/${gameId}/pingpong/match-complete`, {
      method: 'POST',
      body: JSON.stringify(matchData),
    });
  },

  complete: async (gameId, completionData) => {
    return apiCall(`/games/${gameId}/complete`, {
      method: 'POST',
      body: JSON.stringify(completionData || {}),
    });
  },

  delete: async (gameId) => {
    return apiCall(`/games/${gameId}`, {
      method: 'DELETE',
    });
  },

  resetGame: async (gameId) => {
    return apiCall(`/games/${gameId}/pingpong/reset`, {
      method: 'POST',
    });
  },

  pause: async (gameId, { reason, durationMinutes }) => {
    return apiCall(`/games/${gameId}/pause`, {
      method: 'POST',
      body: JSON.stringify({ reason, durationMinutes }),
    });
  },

  resume: async (gameId) => {
    return apiCall(`/games/${gameId}/resume`, {
      method: 'POST',
    });
  },
};

export default pingpongGameAPI;
